module.exports = __webpack_public_path__ + "img/madeira.c2491a33.svg";